module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/diffuser@3x_557f74.png";